module.exports = __webpack_public_path__ + "img/oreal_canada.dd6eef3c.webp";